import CustomButton from 'Components/CustomButton'
import CustomDialog from 'Components/CustomDialog/CustomDialog'
import useTypedSelector from 'Store'
import { LinearProgress } from '@mui/material'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import type { FC } from 'react'
import { t } from 'ttag'

const DeliverDialog: FC<{
  open: boolean
  handleClose: () => void
  handleSubmit: () => void
}> = ({ open, handleClose, handleSubmit }) => {
  const theme = useTheme()

  const { deliverLoading } = useTypedSelector(state => state.order)

  const isLoading = deliverLoading === 'pending'

  return (
    <CustomDialog open={open} handleClose={handleClose}>
      <DialogTitle>{t`Request order delivery`}</DialogTitle>
      <DialogContent>
        {isLoading ? (
          <LinearProgress />
        ) : (
          <DialogContentText>
            <Typography component="span" color="text.primary">
              {t`Are you sure you want to request the order delivery?`}
            </Typography>
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ color: theme.palette.text.primary }}
          onClick={handleClose}
        >{t`Cancel`}</Button>
        <CustomButton onClick={handleSubmit} disabled={isLoading} autoFocus>
          {t`Send request`}
        </CustomButton>
      </DialogActions>
    </CustomDialog>
  )
}

export { DeliverDialog }
